//
// Skip Wins Button

skipWinsButton = {};

skipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addSkipWinPlatformEnabledFlag(button);

  button.canEnable = function () {
    return (
      winlineAnimationController.isAnimating &&
      !this._flags.modal.active &&
      this._flags.skipWinPlatformEnabled
    );
  };

  button.canShow = function () {
    return (
      winlineAnimationController.isAnimating &&
      this._flags.skipWinPlatformVisible
    );
  };

  button.onPressedCallback = function () {
    resourceManager.getController("inputOverlord").disableAll();
    winlineAnimationController.skipAnimations();
    if (button.soundName !== "") button.playSound();
  };

  return button;
};

skipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
skipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "skipWinsButton",
  skipWinsButton.create,
  skipWinsButton.initialise,
  skipWinsButton.getFilesRequired
);
